// Add event listener for transcription result
document.addEventListener('transcription-completed', (e) => {
    const textarea = document.querySelector('textarea[wire\\:model="message"]');
    if (textarea) {
        const scope = Alpine.closestDataStack(textarea)[0];
        if (scope) {
            scope.isTranscribing = false;
        }
        // Remplacer le contenu au lieu de l'ajouter

        const existingText = textarea.value;
        const newText = e.detail;
        textarea.value = existingText ? existingText + ' ' + newText : newText;
        textarea.dispatchEvent(new Event('input'));
    }
});
